import { useCallback, useEffect, useState } from "react";
import { Card, Button, Alert } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import Block from "../../../components/Block/Block";
import { Icon } from "../../../components";
import { getGrnApi } from "../../../services/GrnService";
import BarLoader from "../../../components/Loader/BarLoader";
import GRNAssetUnitListCard from "./AssetUnitList";
import { useSelector } from "react-redux";
import { OnlyStoreManager } from "../../../router/permission";
function GRNDetailsPage() {
  const role = useSelector((state) => state.auth.user?.role || "user");
  const navigate = useNavigate();
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchData = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await getGrnApi(id);
      setData(response.data.results);
    } catch (error) {
      setError(error.response?.data?.error || "");
      setData([]);
    } finally {
      setIsLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  if (isLoading) {
    return (
      <div class="position-absolute top-50 start-50 translate-middle">
        <div className="text-center">
          <BarLoader color="#255D5C" size={50} />
        </div>
      </div>
    );
  }
  if (error.length) {
    return (
      <Alert variant={"danger"}>
        <div className="d-flex flex-column align-items-center">
          <strong>{error}</strong>
          <Button variant="danger" size="sm" onClick={() => navigate("/grn")}>
            <Icon name="arrow-left" />
            <span>Back</span>
          </Button>
        </div>
      </Alert>
    );
  }

  return (
    <div>
      <div className="d-flex justify-content-between gap-2 flex-wrap mb-3">
        <div>
          <h2>GRN Details</h2>
          <nav>
            <ol className="breadcrumb breadcrumb-arrow mb-0">
              <li className="breadcrumb-item">
                <Link to="/">Dashboard</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/grn">GRN List</Link>
              </li>
              {/* <li className="breadcrumb-item"><Link to="/user-manage/user-list">User Manage</Link></li> */}
              <li className="breadcrumb-item active" aria-current="page">
                GRN Details
              </li>
            </ol>
          </nav>
        </div>
        {OnlyStoreManager.includes(role) && (
          <button
            onClick={() => navigate(`/add-asset/${id}`)}
            className="btn btn-primary align-self-center"
          >
            <Icon name="plus" />
            <span>Add Asset</span>
          </button>
        )}
      </div>

      <Block>
        <Card className="p-2">
          <div className="d-flex gap-1 flex-column flex-md-row align-items-md-top align-items-start justify-content-md-between justify-content-start ">
            <div className="d-flex flex-column">
              <div className="d-flex gap-2 align-items-center">
                <span className="text-light">GRN Number</span>
                <span className="fw-bold">{data.grn_number}</span>
              </div>
              <div className="d-flex gap-2 align-items-center">
                <span className="text-light">Received Date</span>
                <span className="fw-bold">{data.received_date}</span>
              </div>
              <div className="d-flex gap-2 align-items-center">
                <span className="text-light">GRN Created At</span>
                <span className="fw-bold">{data.created_at}</span>
              </div>
            </div>

            <div className="d-flex flex-column">
              <h5 className="text-light text-md-center">Vendor</h5>
              {data.vendor ? (
                <>
                  <div className="d-flex gap-2 align-items-center">
                    <span className="text-light">Name:</span>
                    <span className="fw-bold">{data.vendor.name}</span>
                  </div>
                </>
              ) : (
                <span className="bg-light p-1 rounded py-0">
                  Not Available !
                </span>
              )}
            </div>

            <div className="d-flex flex-column">
              <h5 className="text-light text-md-center">Invoice</h5>
              {data.invoice_number ? (
                <>
                  <div className="d-flex gap-2 align-items-center">
                    <span className="text-light">Name:</span>
                    <span className="fw-bold">{data.invoice_number}</span>
                  </div>
                </>
              ) : (
                <span className="bg-light p-1 rounded py-0">
                  Not Available !
                </span>
              )}
            </div>
          </div>
        </Card>
        <GRNAssetUnitListCard grnId={id} />
      </Block>
    </div>
  );
}

export default GRNDetailsPage;
